import { type HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type SkeletonProps = HTMLAttributes<HTMLDivElement>

export function Skeleton({ className, ...props }: SkeletonProps) {
  return <div className={cn('animate-pulse', className)} {...props} />
}
Skeleton.displayName = 'Skeleton'
